import type { EffectBuildableId } from "@skilitics/nautilus-core-designer-data";

import type { GetDesignerNodeById } from "../../state/index.ts";
import type { EffectBuildable } from "../../types/index.ts";
import type { GetNodeEffectBuildables } from "../querying/index.ts";

const isMatchCreate = (id: EffectBuildableId) => (b: EffectBuildable) => b.nodeId === id.nodeId && b.name === id.name;

export const getEffectBuildableCreate =
  (
    getEffectBuildables: GetNodeEffectBuildables,
    getById: GetDesignerNodeById,
    coreEffectBuildables?: ReadonlyArray<Omit<EffectBuildable, "nodeId">>,
  ) =>
  (id: EffectBuildableId): EffectBuildable | undefined => {
    const isMatch = isMatchCreate(id);
    const buildable = getEffectBuildables(getById(id.nodeId)).find(isMatch);
    if (!buildable && coreEffectBuildables) {
      return coreEffectBuildables.map((b) => ({ ...b, nodeId: id.nodeId })).find(isMatch);
    }
    return buildable;
  };

export type GetEffectBuildable = ReturnType<typeof getEffectBuildableCreate>;
